import { selectSubscriptionData } from '@liefersoft/pos-ui-core'
import { createSelector } from 'reselect'
import { selectIsAuthorized } from '../system'

export const selectCompanyRegistrationData = store => store.company?.registrationData

export const selectIsOwnerCompany = createSelector(
	selectCompanyRegistrationData,
	(registrationData) => registrationData?.companyType === 'OWNER_COMPANY'
)

export const selectCompanyData = store => store.company?.companyData

export const selectIsFilialCompany = createSelector(
	selectCompanyData,
	(companyData) => companyData?.franchiseMetaData?.type === 'FILIAL'
)

export const selectIsSubscriptionModalActive = createSelector(
	selectIsAuthorized,
	selectSubscriptionData,
	(isAuthorized, subscriptionData) => {
		const { isTestMode, isDeactivated, dateDifferenceInDays, isUnpaid, isEmergencyBlocked, willBeEmergencyBlocked } = subscriptionData

		if (!isAuthorized) {
			return false
		} else if (willBeEmergencyBlocked) {
			return false
		} else if (isTestMode && isDeactivated) {
			return true
		} else if (isTestMode && dateDifferenceInDays > 0 && dateDifferenceInDays < 15) {
			return true
		} else if (isEmergencyBlocked) {
			return true
		} else if (isUnpaid && !isDeactivated && dateDifferenceInDays < 8) {
			return true
		} else if (isUnpaid && isDeactivated) {
			return true
		} else if (isDeactivated) {
			return true
		} else {
			return false
		}
	},
)
